<template>
  <div class="StarRating">
    <span
      v-for="star in 5"
      :key="star"
      class="StarRating__star"
      :class="{
        'StarRating__star--filled': star <= Math.floor(rating),
        'StarRating__star--half':
          star === Math.ceil(rating) && rating % 1 !== 0,
      }"
    >
      ★
    </span>
  </div>
</template>

<script setup lang="ts">
defineProps({
  rating: {
    type: Number,
    required: true,
    validator: (value: number) => value >= 0 && value <= 5,
  },
})
</script>

<style lang="scss" scoped>
.StarRating {
  --size: 24px;
  display: inline-flex;
  gap: 0.125rem;

  .StarRating__star {
    font-size: var(--size);
    line-height: 1;
    color: $color-ui-gray-cool-100;
    transition: color 0.2s ease;

    &--filled {
      color: #fdb022;
    }

    &--half {
      background: linear-gradient(
        90deg,
        #fdb022 50%,
        $color-ui-gray-cool-100 50%
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}
</style>


